export const SCREEN_BREAKPOINTS = {
  DEFAULT: 0,
  XS: 450,
  SM: 600,
  MD: 720,
  LG: 900,
  GL: 1024,
  XL: 1280,
  "2XL": 1440,
};
